import { NgModule } from '@angular/core';
import { NgChartsModule } from 'ng2-charts';
import 'chartjs-adapter-moment';

@NgModule({
  exports: [NgChartsModule],
})
export class ChartsModule {}
